import React, { Component, Fragment } from 'react';
import api from '../../../services/api';
import ModalConfirm from '../../common/modal-confirm';
import ModalAlert from '../../common/modal-alert';
import Pagination from '../../../components/Common/pagination';
class Permission extends Component {

    state = {
        load: false,
        documents: {},
        idDocument: null,
        erroDelete: false,
        description: "",
        insertDocument: false,
        functions: {},
        documentTypes: {},
        msgError: null,
        msgSuccess: null,
        nameDocument: '',
        documentType: null,
        functionDocument: null,
        msgAlert: "",
        documentFunctionId: "",
        documentTypeId: "",
        classText:'',
        paginas:0,
        functionsSelected:[],
        page: 1
    }

    componentDidMount() {
        this.searchDocuments();
        this.searchFunctions();
    }

    searchDocuments = async (e) => {
        let page = (e)?e.target.id:1;
        this.setState({ load: true, page });
        const response = await api.get(`/documents?order_by=id&order_direction=DESC&page=${page}`);
        this.setState({ documents: response.data.rows, load: false, paginas: response.data.pages || 0 });
    }

    searchFunctions = async () => {
        const response = await api.get(`/functions?status=1`);
        this.setState({ functions: response.data.rows });
    }

    searchDocumentType = async () => {
        const response = await api.get(`/document-types?status=1`);
        this.setState({ documentTypes: response.data.rows });
    }

    deleteDocument = async (e) => {
        const id = e.target.id;
        if (id) {
            this.setState({ idDocument: id, erroDelete: null });
            document.getElementById("modal-confirm").click();
        }
    }

    confirmDeleteDocument = async () => {
        this.setState({ load: true });
        try {
            const response = await api.delete(`/documents/${this.state.idDocument}`);
            this.searchDocuments();
            this.setState({ load: false, idDocument: null, erroDelete: null });
            document.getElementById('close-modal-confirm').click();

            document.getElementById("modal-alert").click();
            this.setState({ msgAlert: response.data.msg, classText: "text-success" });

        } catch (err) {
            let msg = (err.response.data.errors) ? err.response.data.errors[0].msg : err.response.data.msg;
            this.setState({ erroDelete: msg });
        };
    }

    alterDocument = (e) => {
        const id = e.target.id;
        const doc = this.state.documents.filter((item) => (item.id == id));

        document.getElementById("nameDocument").value = doc[0].description;
        this.searchFunctions();
        this.searchDocumentType();

        this.setState({
            msgError: null, 
            msgSuccess: null,
            idDocument: id,
            functionsSelected: (doc[0].Functions) ? doc[0].Functions.map(item => item.id) : [],
            nameDocument: doc[0].description,
            documentTypeId: (doc[0].DocumentTypeId) ? doc[0].DocumentTypeId : 0,
            documentFunctionId: (doc[0].FunctionId) ? doc[0].FunctionId : 0
        });
    }

    insertDocument = () => {
        this.searchFunctions();
        this.searchDocumentType();
        document.getElementById('nameDocument').value = '';

        this.setState({ 
            insertDocument: true, 
            msgError: null, 
            msgSuccess: null,
            nameDocument:'', 
            documentFunctionId: '', 
            documentTypeId: '', 
            load: false 
        });
    }

    createDocument = async () => {
        let nameDocument = document.getElementById('nameDocument').value;

        let documentType = document.getElementById('documentType');
        let DocumentTypeId = documentType.options[documentType.options.selectedIndex].value;
        DocumentTypeId = (DocumentTypeId) ? DocumentTypeId : null;

        let { functionsSelected } = this.state; 
        try {
            let response = await api.post(`/documents`, { description: nameDocument, DocumentTypeId, FunctionIds: functionsSelected });

            this.searchDocuments();
            document.getElementById('nameDocument').value = '';
   
            document.getElementById('documentType').value = '';

            this.setState({
                msgError: null,
                msgSuccess: response.msg,
                insertDocument: false,
                documentFunctionId: "",
                documentTypeId: ""
            });
            document.getElementById('close-modal-express').click();
        } catch (err) {
            this.setState({ msgError: err.response.data.errors[0].msg, msgSuccess: null });
        }
    }

    updateStatus = async (e) => {
        let id = e.target.id;
        let value = (e.target.name == 1) ? 0 : 1;
        document.getElementById("modal-alert").click();

        try {
            const response = await api.put(`/documents/${id}`, { status: value });
            this.setState({ msgAlert: response.data.msg, classText: "text-success" });
            this.searchDocuments();
        } catch (err) {
            this.setState({ msgAlert: err.response.data.errors[0].msg, classText: "text-danger" });
        }
    }

    confirmAlterDocument = async (e) => {
        let nameDocument = document.getElementById('nameDocument').value;

        let documentType = document.getElementById('documentType');
        let DocumentTypeId = documentType.options[documentType.options.selectedIndex].value;
        DocumentTypeId = (DocumentTypeId) ? DocumentTypeId : null;

        let { functionsSelected } = this.state; 

        try {

            let response = await api.put(`/documents/${this.state.idDocument}`, { description: nameDocument, DocumentTypeId, FunctionIds: functionsSelected });
            this.searchDocuments();
            this.setState({ msgError: null, msgError: null, msgSuccess: response.data.msg });

        } catch (err) {
            this.setState({ msgError: err.response.data.errors[0].msg, msgSuccess: null });
        }
    }

    changeFunction = (e) => {
        this.setState({ documentFunctionId: e.target.value });
    }

    removeFunction = async (e) => {
        const newFunctions = this.state.functionsSelected.filter(item =>  parseInt(item) !== parseInt(e.target.id));
        this.setState({functionsSelected:newFunctions});

        // const response = await api.delete(`/companies/${CompanyId}/deletesector/${e.target.id}`);
    }

    addFunction = async () => {
        const { documentFunctionId } = this.state;

        let nameDocument = document.getElementById('nameDocument').value;
        let documentType = document.getElementById('documentType');
        let DocumentTypeId = documentType.options[documentType.options.selectedIndex].value;
        DocumentTypeId = (DocumentTypeId) ? DocumentTypeId : null;

        if(this.state.functionsSelected.indexOf(documentFunctionId) == -1 && documentFunctionId){
            this.setState({ functionsSelected: [...this.state.functionsSelected, documentFunctionId] })
        }
    }

    filterFunction = (id) => {
        return this.state.functions.filter(item => item.id === parseInt(id))[0].description;
    }

    changeDocumentType = (e) => {
        this.setState({ documentTypeId: e.target.value });
    }

    render() {
        return (
            <Fragment>
                <div className="row page-titles">
                    <div className="col-md-5 col-8 align-self-center">
                        <h3 className="text-themecolor">Documentos
                        {(this.state.load) ? <i className="fa fa-spin fa-spinner"></i> : null}
                        </h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">

                            <div className="p-20 text-right">
                                <div className="col-md-2 btn btn-rounded btn-primary" data-toggle="modal" data-target=".modal-alter-document" onClick={this.insertDocument}>Cadastrar</div>
                            </div>

                            <table className="table table-bodered">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Documento</th>
                                        <th>Tipo de Documento</th>
                                        <th>Funções</th>
                                        <th>Editar</th>
                                        <th>Excluir</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(this.state.documents.length) ?
                                        (this.state.documents).map((item) => {
                                            return (
                                                <tr key={item.id}>
                                                    <td>{item.id}</td>
                                                    <td>{item.description}</td>
                                                    <td>{(item.DocumentType)?item.DocumentType.description:''}</td>
                                                    <td> 
                                                        {(item.Functions) ? 
                                                        item.Functions.map((it,idx) => {
                                                            return ((idx == 0) ? <span className="label m-1 label-info" id={idx}>{it.description}</span> : <span className="label m-1 label-info" id={idx}>{it.description}</span>)
                                                        }) 
                                                        : 'Indefinida'}
                                                    </td>
                                                    <td className="td-button">
                                                        <button type="button" id={item.id} onClick={this.alterDocument} data-toggle="modal" data-target=".modal-alter-document" className="btn btn-sm btn-outline-success btn-circle">
                                                            <i id={item.id} className="fa fa-edit"></i>
                                                        </button>
                                                    </td>
                                                    <td className="td-button">
                                                        <button type="button" id={item.id} onClick={this.deleteDocument} className="btn btn-sm btn-outline-danger btn-circle">
                                                            <i id={item.id} className="fa fa-times"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                        : null}
                                </tbody>
                            </table>
                            <Pagination function={this.searchDocuments} paginas={this.state.paginas} curPage={this.state.page} />
                        </div>
                    </div>
                </div>

                <ModalConfirm title="Confirmação" msg="Tem certeza que deseja excluir o documento?" function={this.confirmDeleteDocument} msgError={this.state.erroDelete} />
                <ModalAlert title="Informação" msg={this.state.msgAlert} function="" classText={this.state.classText} />

                <div className="modal fade modal-alter-document" data-backdrop="static" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="myLargeModalLabel">
                                    {(this.state.insertDocument) ? 'Cadastrar ' : 'Alterar '}
                                    Documento
                                {(this.state.load) ? <i className="fa fa-spin fa-spinner"></i> : null}
                                </h5>
                                <button type="button" id="close-modal-express" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <span>Nome do documento <i className="text-danger">*</i></span>
                                            <input type="text" id="nameDocument" className="form-control"></input>
                                        </div>
                                        <div className="col-md-12 ">
                                            <span>Tipo de documento <i className="text-danger">*</i></span>
                                            <select id="documentType" value={this.state.documentTypeId} onChange={this.changeDocumentType} className="form-control">
                                                <option value=""></option>
                                                {(this.state.documentTypes.length) ?
                                                    this.state.documentTypes.map((item) => {
                                                        return <option key={item.id} value={item.id}>{item.description}</option>
                                                    })
                                                    : null}
                                            </select>
                                        </div>
                                        
                                        {this.state.documentTypeId == 3 ? (
                                            <Fragment>
                                                <div className="col-md-6  p-t-20">
                                                    <h5>Adicionar Função:</h5>
                                                    <div className="input-group">
                                                        <select className="form-control custom-select col-md-12" onChange={this.changeFunction}>
                                                        <option value="">Todas</option>
                                                        {
                                                            (this.state.functions.length) ?
                                                                this.state.functions.map((item, index) => {
                                                                    return (
                                                                        <option key={index} value={item.id}>{item.description}</option>
                                                                    )
                                                                })
                                                                : null
                                                        }
                                                    </select>
                                                        
                                                        <span class="input-group-btn">
                                                            <button class="btn btn-info" type="button" onClick={this.addFunction}>
                                                                <i class="fa fa-plus"></i>
                                                                Adicionar                               
                                                            </button>
                                                        </span>
                                                    </div>
                                                </div>
                                                        
                                                <div className="col-md-6 p-t-20">
                                                    <div className="form-group">
                                                        <h5>Funções Vinculadas:</h5>

                                                        <table class="table table-striped">
                                                            <thead>
                                                                <tr>
                                                                <th scope="col"><b>#</b></th>
                                                                <th scope="col"><b>Nome</b></th>
                                                                <th align="right"><b>Ações</b></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>

                                                                {
                                                                    (this.state.functionsSelected.length) ?
                                                                        this.state.functionsSelected.map((item, index) => {
                                                                            return (
                                                                                <tr key={index}>
                                                                                    <th>{item}</th>
                                                                                    <th>{this.filterFunction(item)}</th>
                                                                                    <th align="right">
                                                                                        <button class="btn btn-icon btn-sm btn-danger" type="button" id={item} onClick={this.removeFunction} title="Remover Área gestora">
                                                                                            <i class="fa fa-2x fa-times"  id={item}></i>
                                                                                        </button>
                                                                                    </th>
                                                                                </tr>
                                                                            )    
                                                                        })
                                                                    
                                                                    : <tr><th colspan="3" align="center">Nenhum registro!</th></tr> }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </Fragment>
                                        ) : null }
                                
                                        {(this.state.msgError || this.state.msgSuccess) ?
                                            <div className="col-md-12 p-t-20">
                                                <div className={(this.state.msgSuccess) ? 'alert alert-success' : 'alert alert-danger'}>
                                                    {this.state.msgError}
                                                    {this.state.msgSuccess}
                                                </div>
                                            </div>
                                            : null}

                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                {(this.state.insertDocument) ?
                                    <button className="col-md-2 btn waves-effect waves-light btn-rounded btn-success" onClick={this.createDocument} disabled={(!this.state.documentTypeId)}>
                                        Cadastrar
                            </button>
                                    :
                                    <button className="col-md-2 btn waves-effect waves-light btn-rounded btn-success" onClick={this.confirmAlterDocument}>
                                        Alterar
                                </button>
                                }

                                <button type="button" id="closeModalCreate" className="col-md-2 btn btn-secondary btn-rounded waves-effect" data-dismiss="modal">Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment >
        )
    }

}

export default Permission;